<template>
  <img
    alt="How it works mobile"
    :src="mobileImage"
  >
</template>

<script>
// Images
import howItWorksMobile from '@/assets/images/nlp/howItWorksMobile.png'

export default {
  name: 'NlpHowItWorksImageMobile',
  computed: {
    mobileImage() {
      return howItWorksMobile
    },
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
}
</style>